import { render } from "./SubscriptionSkeleton.vue?vue&type=template&id=d8840568&scoped=true"
const script = {}

import "./SubscriptionSkeleton.vue?vue&type=style&index=0&id=d8840568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8840568"]])

export default __exports__